import { HttpResponse, http } from 'msw';
import { API, BASE_URL_V3 } from '../../../src/common/constants';
import type { CreateTourApiResponse } from '../../../src/store/facade/facadeApiV3';
import { mockItinerary2, mockItinerary3, mockItineraryWithDrivingCoords } from '../data/itineraryMock';
import { tourMock } from '../data/tourMock';

const postURLV3 = `${BASE_URL_V3}${API.endpoints.tour}`;
export const CreateTourHandler = http.post(postURLV3, () => {
    const requestResponse: CreateTourApiResponse = {
        tour: tourMock,
        itineraries: { itineraries: [mockItineraryWithDrivingCoords, mockItinerary2, mockItinerary3] },
    };

    return HttpResponse.json(requestResponse);
});

const putURL = `${BASE_URL_V3}${API.endpoints.tour}/:tourId`;
export const UpdateTourHandler = http.put(putURL, async ({ params }) => {
    const requestTourId = params.tourId as string;
    const requestResponse: CreateTourApiResponse = {
        tour: { ...tourMock, tourId: requestTourId },
        itineraries: { itineraries: [mockItineraryWithDrivingCoords, mockItinerary2, mockItinerary3] },
    };

    return HttpResponse.json(requestResponse, { status: 200 });
});
